<template>
  <div>
    <el-button type="text" size="small" @click="openSee">
      <slot></slot>
    </el-button>

    <el-drawer
        title="订单产品信息"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="true"
        :before-close="closeSee"
    >
      <div style="padding: 20px;">
        <el-table :data="order.product" border style="width: 100%">
          <el-table-column prop="model_code" label="存货编号" width="200"></el-table-column>
          <el-table-column prop="name" label="存货名称" width="260"></el-table-column>
          <el-table-column prop="unit" label="单位"></el-table-column>
          <el-table-column prop="number" label="数量"></el-table-column>
          <el-table-column prop="sale_price" label="单价"></el-table-column>
          <el-table-column prop="pay_price" label="金额"></el-table-column>
          <el-table-column prop="save_price_h" label="含税单价"></el-table-column>
          <el-table-column prop="pay_total" label="价税合计"></el-table-column>
        </el-table>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      openStatus: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    order: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  mounted() {},
  methods: {
    // 筛选
    openSee() {
      const _this = this;
      _this.list = _this.info;
      _this.openStatus = true;
    },
    closeSee() {
      const _this = this;
      _this.list = [];
      _this.openStatus = false;
    },
  },
};
</script>